module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebarf"
  }, [_c('p', {
    staticClass: "fm01"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Front cover. At top: Tamiya’s Pzkpfw ausf H in 1/16 scale built and painted to represent a vehicle of 8.Kompanie, Panzer-Regiment 3. The photographs in the centre depict, from left to right, a Pzkpfw IV of SS-Panzer-Regiment 12 photographed during a training exercise in Belgium prior to the Normandy invasion. A Pzkpfw IV ausf B of Panzer-Regiment 22. The regiment’s 8.Kompanie was composed of very early models of this tank. A Pzkpfw IV ausf H of 5.Kompanie, SS-Panzer-Regiment 12 photographed near the front. The illustration at the foot of the page depicts a Pzkpfw IV ausf H of 7.Kompanie, SS-Panzer-Regiment 1. This vehicle is also shown in the Camouflage & Markings section of this book")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-824a2dd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Fm02.vue
// module id = 66
// module chunks = 0